// eslint-disable-next-line import/prefer-default-export
export const GET_BORROW_COMPOSITION_DATA = 'GET_BORROW_COMPOSITION_DATA';
